import { DESKTOP_TARGET_INSTANCE_ID_QUERY_KEY } from '@heidi/agents/contracts';
import { rpaBridge } from '@heidi/plugin-rpa';
import { isTauri } from '@heidi/runtime/platform';
import { useQuery } from '@tanstack/react-query';

import { useNativeInstanceIdentity } from './nativeInstanceIdentity';

export const readNativeInstanceId = async (): Promise<string | null> =>
  isTauri() && rpaBridge.isAvailable() ? rpaBridge.desktopTargetInstanceId() : null;

export const useNativeInstanceId = (enabled: boolean) => {
  const userRefId = useNativeInstanceIdentity();
  return useQuery({
    queryKey: [...DESKTOP_TARGET_INSTANCE_ID_QUERY_KEY, userRefId],
    queryFn: readNativeInstanceId,
    enabled: enabled && !!userRefId && isTauri() && rpaBridge.isAvailable(),
    retry: false,
  });
};
